import React, { useMemo } from 'react';
import ClientInvoiceItemFields, {
    formValueToInvoiceItem,
    getDefaultFormValue,
    newEntryFormValue,
} from '../../../../shared/ClientInvoiceItems/ClientInvoiceItemFields';
import useOrganizationClientRecordInvoiceItems from '../../../../../hooks/api/useOrganizationClientRecordInvoiceItems';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { Form } from '../../../../v2BaseComponents/Form';
import { getIntl } from '../../../../../utils/intl';

const intl = getIntl('profiles.editClientBillingInfoScreen.edit', {
    update: 'Update',
});

export type EditInvoiceItemContentOwnProps = {
    onUpdateInvoiceItem: () => void;
    onCancel: () => void;
    clientRecordId: string;
    invoiceItemId: string;
};

export type EditInvoiceItemContentProps = EditInvoiceItemContentOwnProps;

const EditInvoiceItemContent: React.FC<EditInvoiceItemContentProps> = ({
    clientRecordId,
    onUpdateInvoiceItem,
    onCancel,
    invoiceItemId,
}) => {
    const { updateInvoiceItem, isUpdatingInvoiceItem, isLoadingInvoiceItem, invoiceItem } =
        useOrganizationClientRecordInvoiceItems({
            clientRecordId,
            onUpdatedInvoiceItem: onUpdateInvoiceItem,
            invoiceItemId,
        });
    const initialValue = useMemo(() => (invoiceItem ? getDefaultFormValue(invoiceItem) : null), [invoiceItem]);

    return (
        <AnimateLoadedContent isLoading={isUpdatingInvoiceItem || isLoadingInvoiceItem || !initialValue}>
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={newEntryFormValue}
                    onSubmit={(values) => {
                        const invoiceItem = formValueToInvoiceItem(values);
                        updateInvoiceItem({
                            invoiceItem,
                            invoiceItemId,
                        });
                    }}
                    onCancel={onCancel}
                    saveText={intl('update')}
                    saveIcon="CheckCircle"
                >
                    {({ values }) => <ClientInvoiceItemFields values={values} />}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditInvoiceItemContent);
